import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function FamilySettingsEditClan() {

    const { menu, toggleMobileMenu } = useAppLayout();
    const navigate = useNavigate();
  const queryClient = useQueryClient();

  const loggedFamilyAdmin = localStorage.getItem('family_admin');
  const [clanModalOpen, setClanModalOpen] = useState(false);
  const [selectedClanId, setSelectedClanId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false); // NEW

  // Fetch family_data + clans in one request (backend should return both)
  const { data, isLoading, isError } = useQuery({
    queryKey: ['clanSettings'],
    queryFn: () =>
      axios.get(`${API_URL}/clans-settings-api`, { withCredentials: true })
        .then(res => res.data),
    staleTime: 0,
    gcTime: Infinity,
  });

  const familyData = data?.family_data || {};
  const clanList = data?.clans || [];

  useEffect(() => {
    if (familyData?.clan_id) {
      setSelectedClanId(familyData.clan_id);
    }
  }, [familyData]);

  const openModal = () => {
    setSelectedClanId(familyData?.clan_id || (clanList[0]?.id ?? null));
    setClanModalOpen(true);
  };

  const handleUpdateClan = () => {
    if (!selectedClanId || isNaN(selectedClanId)) {
      toast.error('Invalid clan selected.', { position: 'top-right', autoClose: 3000 });
      return;
    }

    setIsUpdating(true); // disable button
    axios.put(`${API_URL}/update-clan-settings-api`, { clan_id: selectedClanId }, { withCredentials: true })
      .then(() => {
        toast.success('Clan updated successfully', { position: 'top-right', autoClose: 3000 });
        setClanModalOpen(false);
        queryClient.invalidateQueries(['clanSettings']);
        navigate('/family-settings');
      })
      .catch(err => {
        console.error('Update failed:', err.response?.data || err.message);
        toast.error('Update failed. Please try again.', { position: 'top-right', autoClose: 3000 });
      })
      .finally(() => {
        setIsUpdating(false); // re-enable button
      });
  };


  
  if (isLoading) {
    return (
      <div className='loadingspinnerDiv'>
        <div className='loadingspinner'></div>
      </div>
    );
  }

  if (isError) return <p>Error loading clan data.</p>;

  const currentClanName = clanList.find(c => c.id === familyData?.clan_id)?.clan_name || 'Not Set';

   

    return (
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">

                    <div className="vstack gap-3">

                    <div className='row'>
                                  <div className='col-3 col-md-3'>
                                    <Link to='/family-settings' style={{ textDecoration: 'none', color: '#184A2C' }}>
                                      <i className='fa fa-arrow-left' style={{ fontSize: '18px' }}></i>
                                    </Link>
                                  </div>
                                </div>
                    
                                <div className='row'>
                                <div className='col-3 col-md-3'>
                                    </div>
                                  <div className='col-6 col-md-6'>
                                    <div className='card'>
                                      <div className='card-body'>
                                        <p style={{ fontWeight: '600', textAlign: 'center' }}>Edit Clan</p>
                                        <div className='mt-4 border rounded p-3 d-flex align-items-center'>
                                          <p className='mb-0'>
                                            <strong>Clan:</strong> {currentClanName}
                                          </p>
                                          {loggedFamilyAdmin === '1' && (
                                            <button
                                              onClick={openModal}
                                              className='btn btn-link p-0'
                                              style={{ color: '#184A2C', marginLeft: '2%' }}
                                            >
                                              <i className='fas fa-edit' style={{ fontSize: '16px' }}></i>
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                    
                                  <ReactModal isOpen={clanModalOpen} onRequestClose={() => setClanModalOpen(false)}
                                    className='Modal' overlayClassName='Overlay'>
                                    <div className='modal-header'>
                                      <h5 className='modal-title'>Edit Clan</h5>
                                      <button type='button' className='btn-close modalCloseButton' onClick={() => setClanModalOpen(false)}></button>
                                    </div>
                                    <div className='modal-body'>
                                      <label>Clan Name</label>
                    
                                      <select
                          className="form-select"
                          value={selectedClanId || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "insert_clan") {
                              navigate("/family-settings-edit-clan-add");
                            } else {
                              setSelectedClanId(parseInt(value));
                            }
                          }}
                        >
                          <option>Select Clan</option>
                          {clanList.map((clan) => (
                            <option key={clan.id} value={clan.id}>
                              {clan.clan_name}
                            </option>
                          ))}
                    
                          <option value="insert_clan" style={{ fontWeight: "900" }}>
                            Insert your clan
                          </option>
                        </select>
                    
                              
                                    </div>
                                    <div className='modal-footer'>
                                      <button
                                        className='btn btn-primary'
                                        onClick={handleUpdateClan}
                                        disabled={isUpdating} // disable during update
                                      >
                                        {isUpdating ? 'Updating...' : 'Update Clan'}
                                      </button>
                                    </div>
                                  </ReactModal>
                                </div>

                    </div>
                    </div>
                </div>
            </div>
        
    );
}

export default FamilySettingsEditClan;
